module.exports = __webpack_public_path__ + "media/images/icons/career-done-f3eb5b1d042eb803a2421c3787b1b570.svg";